import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './AvisoPlotagemUpgrade.module.scss';
import PlanoAvisoPlotagemUpgrade from '../../../Static/images/plano-aviso-plotagem-upgrade.png';
import { Icon } from '../../../Components/UI';
import Button from '../../../Components/UI/Button';

interface IAvisoObraUpgrade {
  visible?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  role?: number;
}

const AvisoPlotagemUpgrade: FC<IAvisoObraUpgrade> = ({ onConfirm, role }) => {
  const { t } = useTranslation('plotagens');

  return (
    <div className={styles['wrapper']}>
      <div className={styles['imageWrapper']}>
        <img src={PlanoAvisoPlotagemUpgrade} alt="" />
      </div>
      <div className={`${styles['contentWrapper']}`}>
        <div>
          <label className={styles['avisoLimiteObras']}>
            {role === 1
              ? t('avisoUpgrade.warningAdmin')
              : t('avisoUpgrade.warningCompany')
            }
          </label>
        </div>
        <h2>
          {role === 1
            ? t('avisoUpgrade.upgradeAdmin')
            : t('avisoUpgrade.upgradeCompany')
          }
        </h2>
        <h3>{t('avisoUpgrade.subtitle')}</h3>

        <p>{t('avisoUpgrade.premiumAlsoProvides')}</p>
        <div className={styles['icons-wrapper']}>
          <div className={`${styles['icons-text-wrapper']} ${styles['icons-text-margin']}`}>
            <div>
              <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} /> 
              <span>{t('avisoUpgrade.feature2d3d')}</span>
            </div>
            <div>
              <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
              <span>{t('avisoUpgrade.featureNomenclature')}</span>
            </div>
          </div>
          <div className={styles['icons-text-wrapper']}>
            <div>
              <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} /> 
              <span>{t('avisoUpgrade.featureUsersRoles')}</span>
            </div>
            <div>
              <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} /> 
              <span>{t('avisoUpgrade.featurePlotting')}</span>
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>&nbsp;</div>
        </div>
        
        <div className={styles['button-wrapper']}>
          <Button className={styles['button-confirm']} type='primary' ispremium="true" width={287} height={48} onClick={onConfirm}>
            <Icon icon="crown" className={styles['icon']} size="xxs" customColor={'#324150'} />
            {role === 1
              ? t('avisoUpgrade.acquirePremium')
              : t('avisoUpgrade.requestPremium')
            }
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AvisoPlotagemUpgrade;
